import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from 'react-redux';
import { Table } from 'react-bootstrap';

import { ContainerWrapper, Content, Row, Col } from '../../components/GridComponent/AdminLte.js';
import PageLoading from "../PageLoading";
import Wrapper from "../../components/Template/Wrapper";
import { fetchBroadcastReach } from '../../store/actions/broadcasts/broadcastActions';
import "./Broadcasts.css";

/**
 * Announcements -> Manage -> Reach. Audience size and how far an item got (shown, dismissed,
 * acknowledged, completed) for the current period, with country / department breakdowns.
 */

// Keys as the server sends them (BroadcastController::reach): the audience size is `audience`.
const METRICS = [
  ["Audience", "audience"],
  ["Shown", "shown"],
  ["Dismissed", "dismissed"],
  ["Acknowledged", "acknowledged"],
  ["Completed", "completed"],
];

// Breakdown rows carry country_id / department_id (a null department is one row, "no department").
const rowKey = (row, i) => {
  const id = row.country_id !== undefined ? row.country_id : row.department_id;
  return id === null || id === undefined ? "none-" + i : String(id);
};

const Breakdown = ({ caption, rows }) => (
  <Table size="sm" className="broadcast-breakdown" aria-label={caption}>
    <caption>{caption}</caption>
    <thead><tr><th>Name</th><th>Count</th></tr></thead>
    <tbody>
      {(rows || []).map((row, i) => (
        <tr key={rowKey(row, i)}><td>{row.name}</td><td>{row.count}</td></tr>
      ))}
    </tbody>
  </Table>
);

class BroadcastReach extends Component {

  state = {
    loaded: false, // the fetch answered (the store holds null for both "loading" and "failed")
  };

  componentDidMount() {
    this.props.fetchBroadcastReach(this.props.params.id).then(() => this.setState({ loaded: true }));
  }

  renderReport = (reach) => (
    <>
      <Row>
        {METRICS.map(([label, key]) => (
          <Col size="2" key={key}>
            <div className="broadcast-metric">
              <span className="broadcast-metric-label">{label}</span>
              <span className="broadcast-metric-value">{Number(reach[key] || 0)}</span>
            </div>
          </Col>
        ))}
        <Col size="2">
          <div className="broadcast-metric">
            <span className="broadcast-metric-label">Completion rate</span>
            <span className="broadcast-metric-value">{Number(reach.completion_rate || 0) + "%"}</span>
          </div>
        </Col>
      </Row>
      <Row>
        <Col size="6"><Breakdown caption="By country" rows={reach.by_country} /></Col>
        <Col size="6"><Breakdown caption="By department" rows={reach.by_department} /></Col>
      </Row>
    </>
  );

  render() {
    const { reach } = this.props;

    return <Wrapper {...this.props} >
      <ContainerWrapper>
        <Content col="12" title="Announcement reach">
          <p><Link to={global.links.broadcast_manage}>Back to list</Link></p>
          {!this.state.loaded
            ? <PageLoading />
            : (reach ? this.renderReport(reach) : <p>Couldn't load the reach report right now.</p>)
          }
        </Content>
      </ContainerWrapper>
    </Wrapper>;
  }
}

const mapStateToProps = (state) => {
  return {
    user   : state.user,
    reach  : state.broadcasts.reach,
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    fetchBroadcastReach : ( id ) => dispatch( fetchBroadcastReach( id ) ),
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(BroadcastReach);
